import * as React from "react";
import { FolderItem } from "@/types/fse";
import { Users, FolderIcon } from "lucide-react";
import { useNavigate, useSearchParams } from "react-router";
import { useRecentItems } from "@/hooks/use-add-recent-items";
import { supplierContractFamilySearch } from "@/views/drive/supplierContractFamilyNavigation";

interface Props {
  item: FolderItem;
  isShared?: boolean;
}

export const DriveRowNameFolder: React.FC<Props> = ({ item, isShared }) => {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const { addRecentFolder } = useRecentItems();

  const handleOnClick = (e: React.MouseEvent) => {
    e.stopPropagation();
    // Track folder access for recent items
    addRecentFolder(item);
    navigate(`/drive/${item.id}${supplierContractFamilySearch(searchParams)}`);
  };

  return (
    <div className="min-w-0">
      <div className="flex min-w-0 cursor-pointer items-center" onClick={handleOnClick}>
        <FolderIcon className="mr-2 h-5 w-5 shrink-0 text-brand-gold-700" />
        <span className="flex min-w-0 flex-1 truncate font-medium" title={item.name}>
          {item.name}
          {isShared && <Users className="ml-2 mt-1 h-3 w-3 text-gray-500" />}
        </span>
      </div>
    </div>
  );
};
